import { cn } from '@massilia/ui'
import { ArrowBigUp } from 'lucide-react'

import { useScrollInfo } from '@/utils/use-scroll-info'

interface BackToTopButtonProps {
  className?: string
  threshold?: number
}

export function BackToTopButton({ className, threshold = 300 }: BackToTopButtonProps) {
  const { scrollY } = useScrollInfo()

  const scrollToTop = () => {
    window.scrollTo({ behavior: 'smooth', top: 0 })
  }

  return (
    <button
      aria-label="Retour en haut"
      className={cn(
        'fixed top-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg transition-all duration-300 hover:cursor-pointer hover:bg-blue-700',
        'border border-gray-800/30 backdrop-blur-sm',
        scrollY > threshold
          ? 'translate-y-0 opacity-100'
          : 'pointer-events-none -translate-y-4 opacity-0',
        className
      )}
      onClick={scrollToTop}
      type="button"
    >
      <ArrowBigUp className="h-6 w-6" />
    </button>
  )
}
